import { ChangeDetectionStrategy, Component, input, OnDestroy } from '@angular/core';
import { CatalogConstants } from '@app/catalog';
import { BreadcrumbItemToggleMessage, IBreadcrumbItemModel, Messenger } from '@app/shared';
import { Subject } from 'rxjs';

@Component({
  selector: 'catalog-carousel-item',
  templateUrl: './catalog-carousel-item.component.html',
  styleUrl: './catalog-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CatalogCarouselItemComponent<T> implements OnDestroy  {
  public data = input.required<T>();

  private readonly destroying$ = new Subject<void>();


  constructor(private messenger: Messenger)
  {}

  public addToBreadCrumb(item: IBreadcrumbItemModel) {
    console.log('Breadcrumb item added:', item);
    this.messenger.send(new BreadcrumbItemToggleMessage(item, CatalogConstants.CATALOG));
  }

  ngOnDestroy() {
    this.destroying$.next(undefined);
    this.destroying$.complete();
  }
}
